import * as React from 'react';

import Box from '@mui/material/Box';

export default function Banner(){
    return (
        <Box className='banner'>
            <Box className='content-wrapper'>
                <Box className='content'>
                    <h1 className='title'>FINANCE MANAGEMENT ASSOCIATE PROGRAM </h1>
                    <p className='subtitle'>Launch A Future-Ready Finance Career Where Accounting Meets Technology</p>
                    <p className='sub-subtitle'>Preparing Future Finance Talents for a Technology-Enabled World.</p>
                     <a className='btn-apply' href="https://career.sea.com/position/J02176826" style={{minWidth: "100px"}}>APPLY NOW</a> 
                </Box>
            </Box>
        </Box>
    );
}